<div class="card">
    <app-header titulo="Depreciações" descricao="Integração das depreciações"></app-header>

    <p-table [value]="depreciacoes"  [loading]="loading" #dt [globalFilterFields]="['instancia','periodoReferencia','cdEquiptoErp','empresaPims','cdContaErp','vlTotal']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
        
        <ng-template pTemplate="caption">
            <div class="flex">
                <p-dropdown class="ml-3" [style]="{'width':'100%'}" appendTo="body" [options]="instancias" optionValue="id" optionLabel="nome" [(ngModel)]="instanciaSelecionada" dataKey="id" inputId="id" placeholder="Instância" emptyMessage="Nenhuma instância"></p-dropdown>
                <p-calendar  class="ml-3"
                    [(ngModel)]="date" 
                    [showIcon]="true" 
                    view="month" 
                    dateFormat="mm/yy" 
                    [readonlyInput]="true" 
                    placeholder="Selecione o período"/>
                <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="integrar()" label="Integrar" [loading]="loadingInteg" ></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                </span>
                <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="carregar()"></button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Instância</th>
                <th>Período</th>
                <th>Equipamento</th>
                <th>Empresa PIMS</th>
                <th>Conta ERP</th>
                <th>Valor</th>
                <th>Dt Recebido</th>
                <th>Status</th>
                <th>Dt Integrado PIMS</th>
                <th>Mensagem</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-depreciacao>
            <tr>
                <td>{{ depreciacao.instancia }}</td>
                <td>{{ depreciacao.periodoReferencia }}</td>
                <td>{{ depreciacao.cdEquiptoErp }}</td>
                <td>{{ depreciacao.empresaPims }}</td>
                <td>{{ depreciacao.cdContaErp }}</td>
                <td>{{ depreciacao.vlTotal }}</td>
                <td>{{ depreciacao.dtRecebido | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td><app-tag-status [status]="depreciacao.fgStatusInteg"></app-tag-status></td>
                <td>{{ depreciacao.dtIntegPims | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ depreciacao.deMensagemInteg }}</td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <td colspan="10">Nenhum registro encontrado</td>
        </ng-template>
    </p-table>
</div>